var _style, _path, _path2, _path3, _path4, _polygon, _polygon2, _path5, _path6, _path7, _path8, _path9, _rect, _rect2, _path10, _path11, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVerkehrsrechtRotlichtverstoss(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 623.6 432.1",
    style: {
      enableBackground: "new 0 0 623.6 432.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#3F3D56;}\n\t.st1{fill:#137F7B;}\n\t.st2{fill:#FFFFFF;}\n\t.st3{fill:#E6E6E6;}\n\t.st4{fill:#4D5359;}\n\t.st5{fill:#42474C;}\n\t.st6{fill:#454B52;}\n\t.st7{fill:#52585F;}\n\t.st8{fill:#DC3545;}\n\t.st9{opacity:0.35;fill:#FFC107;enable-background:new    ;}\n\t.st10{opacity:0.52;fill:#73BA25;enable-background:new    ;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M184.4,306.4c-5.6,0-10.2,4.6-10.2,10.2v23.9c0,5.6,4.6,10.2,10.2,10.2h12.9c5.6,0,10.2-4.6,10.2-10.2v-23.9 c0-5.6-4.6-10.2-10.2-10.2H184.4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M423.8,351.5h-12.9c-6.1,0-11-4.9-11-11v-23.9c0-6.1,4.9-11,11-11h12.9c6.1,0,11,4.9,11,11v23.9 C434.8,346.6,429.8,351.5,423.8,351.5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M415.2,332.4h-223c-10.1,0-18.4-6-18.4-13.3v-42.9l11.1-11.7h239.8l8.9,11.7V319 C433.6,326.4,425.3,332.4,415.2,332.4z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M423.6,286H186.1l-2.4-37l1.5-3.8l8.9-22H414l12.1,24.9L423.6,286z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "425.6,248.2 423.9,276 371.6,276 371.6,255.4 424.2,245.1 "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "237.3,255.4 237.3,276 185.9,276 184.1,249 185.6,245.3 "
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M412.6,229.5H195.5l23.2-77.2c1.9-6.5,7.9-11.1,14.8-11.1l143.8-1.4c7.2-0.1,13.4,4.7,15.2,11.7L412.6,229.5z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M395.9,222.2L212.1,220c-0.8,0-1.5-0.7-1.5-1.5c0-0.1,0-0.3,0.1-0.4l17.6-55c0.2-0.6,0.8-1,1.4-1h147.8 c0.6,0,1.2,0.4,1.4,1l18.3,57.1c0.3,0.8-0.2,1.6-1,1.9C396.2,222.2,396.1,222.2,395.9,222.2z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M328.8,149.3h-49.5c-0.4,0-0.8-0.4-1-1.1c-0.2-0.7-0.2-1.4,0.1-2.1l4.1-10.3c0.2-0.5,0.5-0.8,0.9-0.8h41.4 c0.4,0,0.7,0.3,0.9,0.8l4.1,10.3c0.2,0.7,0.3,1.4,0.1,2.1C329.6,148.9,329.3,149.3,328.8,149.3z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M195.6,228H163v-7.2c0-4.8,3.9-8.7,8.7-8.7h23.8V228H195.6z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M445.1,228h-32.6v-15.9h23.8c4.8,0,8.7,3.9,8.7,8.7v7.2H445.1z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -4.6,
    y: 368.1,
    transform: "matrix(0.9411 -0.3381 0.3381 0.9411 -120.0758 48.7838)",
    className: "st0",
    width: 169.2,
    height: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 526.2,
    y: 284.5,
    transform: "matrix(0.338 -0.9411 0.9411 0.338 1.5777 740.5082)",
    className: "st0",
    width: 2,
    height: 169.2
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M312.9,381.1h-9.5v-12.3h9.5V381.1z M312.9,356.4h-9.5v-12.3h9.5V356.4z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M312.9,432.1h-9.5v-12.3h9.5V432.1z M312.9,407.4h-9.5v-12.3h9.5V407.4z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "matrix(3.7037033,0,0,3.7037033,-132.29161,-173.95822)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g969",
    transform: "matrix(4.3165907,0,0,4.3165907,-556.26159,-259.39789)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1052",
    className: "st4",
    d: "M142.4,76.2l-2,1.2v5.9l1,0.6l2-1.2v-5.9L142.4,76.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ellipse1100",
    className: "st5",
    d: "M141.4,82.4v12.9l0,0l0,0c0,0.1,0.1,0.2,0.2,0.3c0.2,0.1,0.6,0.1,0.8,0l0,0 c0.1-0.1,0.1-0.1,0.1-0.2l0,0v-13L141.4,82.4L141.4,82.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1104",
    className: "st4",
    d: "M141.4,78l2-1.2v5.9l-2,1.2V78z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1106",
    className: "st6",
    d: "M141.4,83.9l-1-0.6v-5.9l1,0.6V83.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1108",
    className: "st7",
    d: "M140.5,77.4l2-1.2l1,0.6l-2,1.2L140.5,77.4z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "ellipse1110",
    transform: "matrix(0.5677 -0.8232 0.8232 0.5677 -3.3105 151.3171)",
    className: "st8",
    cx: 142.4,
    cy: 78.8,
    rx: 0.9,
    ry: 0.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "ellipse1112",
    transform: "matrix(0.5677 -0.8232 0.8232 0.5677 -4.6288 152.0079)",
    className: "st9",
    cx: 142.4,
    cy: 80.4,
    rx: 0.9,
    ry: 0.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "ellipse1114",
    transform: "matrix(0.5677 -0.8232 0.8232 0.5677 -5.9471 152.6988)",
    className: "st10",
    cx: 142.4,
    cy: 82,
    rx: 0.9,
    ry: 0.5
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerkehrsrechtRotlichtverstoss);
export default __webpack_public_path__ + "static/media/Verkehrsrecht_Rotlichtverstoss.0f346ace7bd37fb3fed5ab5e0bd58c3a.svg";
export { ForwardRef as ReactComponent };